<ng-container>
	<flx-heading [color]="'secondary'" align="center">Bulk Payment File Downloaded</flx-heading>
</ng-container>
